import type { EntityId } from './types'

const NOT_AN_ID = new Set(['', 'undefined', 'null', 'NaN'])

/**
 * Keeps only the real ids of a list — run any id list seeded from a record through this
 * before it reaches a request or a select's value.
 *
 * The **literal strings** `'undefined'` and `'NaN'` are dropped alongside the empty values:
 * a mapper reaching for a field the payload spells differently and calling `String()` on it
 * produces exactly those, and they are truthy and non-empty, so every `?.length` and `!!`
 * guard downstream waves them through and the API is asked to pin a record that
 * cannot exist.
 */
export function compactIds(
  ids: readonly (EntityId | null | undefined)[] | null | undefined
): EntityId[] {
  if (!ids) return []

  return ids.filter((id): id is EntityId => {
    if (id == null) return false
    if (typeof id === 'number') return Number.isFinite(id)

    return !NOT_AN_ID.has(id.trim())
  })
}
